import { Button, Grid, FormControl, RadioGroup, FormControlLabel, Radio, Typography, FormLabel, TextField, FormHelperText } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { AppContext } from "../../../../contexts/AppContext";
import { setStyle } from "../../../../util";
import { UserService } from "../../../../services/user/userService";
import { useNavigate } from 'react-router-dom';
import { AxiosError } from "axios";


const Welcome = () => {
    const { defaultValues } = useContext(AppContext);
    const { server, setServer, socket, jwtToken, setSurvey } = useContext(AppContext);
    const navigate = useNavigate()

    const [hasError, setError] = useState({gender:false,age:false, country:false, educationLevel:false, income:false, buildingType:false, householdSize:false})

    useEffect(() => {
        if (defaultValues) { setStyle(defaultValues); }
    })



    const submitEvent = async (evt:any)=>{
        evt.preventDefault()
        console.log(jwtToken)
        if(jwtToken){
            const object:any = {};
            new FormData(evt.target).forEach((value, key) => {object[key] = value});
            try {
                await UserService.updateSurvey(jwtToken, object)
                setSurvey(object)
                navigate('/game');
            } catch (error:any|AxiosError) {
                console.log(error)
                const errorsList = error.response?.data?.errors
                if(errorsList){
                    const object:any = {}
                    errorsList.forEach((element:any) => {
                        object[element.param] = true
                    });
                    setError({...hasError,...object})
                }
                
            }

            

        }
    }

    return (
        
            <Grid className="container-sondage">
                <Grid className="container-form">
                    <h2 className="serious-title" >Formulaire d’informations sociodémographiques</h2>

                    <Typography className="serious-text-pres" gutterBottom>Avant de débuter la partie, nous vous demandons de répondre à quelques questions socio-économiques. Vous pouvez omettre de répondre à des questions en choisissant l’option « Préfère ne pas répondre »</Typography>

                    <form className="form-sondage" onSubmit={submitEvent}>
                        <FormControl error={hasError.gender}>
                            <FormLabel id="genre">À quel genre vous identifiez-vous?</FormLabel>
                            <RadioGroup
                                aria-labelledby="genre"
                                name="gender"
                            >
                                <FormControlLabel value="Femme" control={<Radio />} label="Femme" />
                                <FormControlLabel value="Homme" control={<Radio />} label="Homme" />
                                <FormControlLabel value="Autre" control={<Radio />} label="Autre" />
                                <FormControlLabel value="Sans reponse" control={<Radio />} label="Préfère ne pas répondre" />
                            </RadioGroup>
                            {hasError.gender && (<FormHelperText>Une réponse doit être sélectionnée.</FormHelperText>)}
                        </FormControl>
                        <FormControl error={hasError.age}>
                            <FormLabel id="age">Dans quelle tranche d’âge vous situez-vous ?</FormLabel>
                            <RadioGroup
                                aria-labelledby="age"
                                name="age"
                            >
                                <FormControlLabel value="18-25" control={<Radio />} label="18-25 ans" />
                                <FormControlLabel value="26-35" control={<Radio />} label="26-35 ans" />
                                <FormControlLabel value="36-45" control={<Radio />} label="36-45 ans" />
                                <FormControlLabel value="45-55" control={<Radio />} label="45-55 ans" />
                                <FormControlLabel value="55-65" control={<Radio />} label="55-65 ans" />
                                <FormControlLabel value="65-75" control={<Radio />} label="65-75 ans" />
                                <FormControlLabel value="75-plus" control={<Radio />} label="75 ans et plus" />
                                <FormControlLabel value="Sans reponse" control={<Radio />} label="Préfère ne pas répondre" />
                            </RadioGroup>
                            {hasError.age && (<FormHelperText>Une réponse doit être sélectionnée.</FormHelperText>)}
                        </FormControl>
                        <FormControl error={hasError.country}>
                            <FormLabel id="pays">Êtes-vous né.e au Canada?</FormLabel>
                            <RadioGroup
                                aria-labelledby="pays"
                                name="country"
                            >
                                <FormControlLabel value="Oui" control={<Radio />} label="Oui" />
                                <FormControlLabel value="Non" control={<Radio />} label="Non" />
                                <FormControlLabel value="Sans reponse" control={<Radio />} label="Préfère ne pas répondre" />
                            </RadioGroup>
                            {hasError.country && (<FormHelperText>Une réponse doit être sélectionnée.</FormHelperText>)}
                        </FormControl>
                        <FormControl error={hasError.educationLevel}>
                            <FormLabel id="scolaire">Quel est votre plus haut niveau de scolarité complétée ou son équivalence ?</FormLabel>
                            <RadioGroup
                                aria-labelledby="scolaire"
                                name="educationLevel"
                            >
                                <FormControlLabel value="Aucun" control={<Radio />} label="Aucun certificat, diplôme ou grade" />
                                <FormControlLabel value="Secondaires" control={<Radio />} label="Diplôme d’études secondaires ou attestation équivalente" />
                                <FormControlLabel value="Metier" control={<Radio />} label="Certificat ou diplôme d’apprenti ou d’une école de métiers" />
                                <FormControlLabel value="Cegep" control={<Radio />} label="Certificat ou diplôme d’un collège ou d’un cégep" />
                                <FormControlLabel value="Universitaire" control={<Radio />} label="Certificat, diplôme ou grade universitaire" />
                                <FormControlLabel value="Sans reponse" control={<Radio />} label="Préfère ne pas répondre" />
                            </RadioGroup>
                            {hasError.educationLevel && (<FormHelperText>Une réponse doit être sélectionnée.</FormHelperText>)}
                        </FormControl>
                        <FormControl error={hasError.income}>
                            <FormLabel id="revenu">Quel est votre revenu familial brut annuel ?</FormLabel>
                            <RadioGroup
                                aria-labelledby="revenu"
                                name="income"
                            >
                                <FormControlLabel value="-25000" control={<Radio />} label="Moins de 25 000$" />
                                <FormControlLabel value="25000–50000" control={<Radio />} label="25 000 – 50 000$" />
                                <FormControlLabel value="50000–75000" control={<Radio />} label="50 000 – 75 000$" />
                                <FormControlLabel value="75000–100000" control={<Radio />} label="75 000 – 100 000$" />
                                <FormControlLabel value="100000–125000" control={<Radio />} label="100 000 – 125 000$" />
                                <FormControlLabel value="+125000" control={<Radio />} label="Plus de 125 000$" />
                                <FormControlLabel value="Sans reponse" control={<Radio />} label="Préfère ne pas répondre" />
                            </RadioGroup>
                            {hasError.income && (<FormHelperText>Une réponse doit être sélectionnée.</FormHelperText>)}
                        </FormControl>
                        <FormControl error={hasError.buildingType}>
                            <FormLabel id="immeuble">Laquelle de ces situations s’applique à vous quant aux services d’eau chaude, d’électricité et de chauffage?</FormLabel>
                            <RadioGroup
                                aria-labelledby="immeuble"
                                name="buildingType"
                            >
                                <FormControlLabel value="proprio" control={<Radio />} label="Je suis propriétaire et je paye pour ces services." />
                                <FormControlLabel value="locataire" control={<Radio />} label="Je suis locataire et je paye pour tous ces services." />
                                <FormControlLabel value="locataire-certains" control={<Radio />} label="Je suis locataire et je paye pour certains de ces services." />
                                <FormControlLabel value="locataire-inclus" control={<Radio />} label="Je suis locataire et tous ces services sont inclus dans mon bail." />
                                <FormControlLabel value="autre" control={<Radio />} label="Une autre situation s’applique à moi." />
                                <FormControlLabel value="Sans reponse" control={<Radio />} label="Préfère ne pas répondre" />
                            </RadioGroup>
                            {hasError.buildingType && (<FormHelperText>Une réponse doit être sélectionnée.</FormHelperText>)}
                        </FormControl>
                        <FormControl error={hasError.householdSize}>
                            <FormLabel id="personne">Combien de personnes habitent dans votre logement (y compris vous-même)?</FormLabel>
                            <RadioGroup
                                aria-labelledby="personne"
                                name="householdSize"
                                
                            >
                                <FormControlLabel value="1" control={<Radio />} label="1" />
                                <FormControlLabel value="2" control={<Radio />} label="2" />
                                <FormControlLabel value="3" control={<Radio />} label="3" />
                                <FormControlLabel value="4" control={<Radio />} label="4" />
                                <FormControlLabel value="5" control={<Radio />} label="5" />
                                <FormControlLabel value="6" control={<Radio />} label="6 et plus" />
                                <FormControlLabel value="Sans reponse" control={<Radio />} label="Préfère ne pas répondre" />
                            </RadioGroup>
                            {hasError.householdSize && (<FormHelperText>Une réponse doit être sélectionnée.</FormHelperText>)}
                        </FormControl>
                        <TextField
                            className="serious-input"
                            fullWidth
                            label='Dans quelle ville habitez-vous?'
                            name="city"
                            variant="outlined"
                            sx={{ "marginTop": ".5em", "marginBottom": ".5em" }}
                            InputLabelProps={{
                                    shrink: true,
                                }} />

                        <Button variant='contained' className="serious-btn" type="submit">Soumettre</Button>
                    </form>

                </Grid>
            </Grid>
        

    );
};

const Container = styled.div`
    display: flex;
    padding: 1em;
    border-radius: 5px;
`


const Main = styled.div`
    display: flex;
    flex-direction: column;
    padding: 2em;
    align-self: center;
`

const TopSubdivision = styled.div`
    display: flex;
`

const BottomSubdivision = styled.div`
    margin: auto;
    margin-top: 1em;
`


export default Welcome;